import { useParams, usePathname } from 'next/navigation';

import useAcl from '@/utils/hooks/user/useAcl';

// Utils
import { formatObjectWithUrlKeys } from '@/utils/urls/formatUrl';

import { userPermissionsHasAccess } from '@/lib/acl/pageHasAccess';
// Lib
import { HOMEPAGE } from '@/lib/routes/privateRoutes';

export const usePageHasPermissions = () => {
    const { hasAcl } = useAcl();
    const params = useParams();

    /**
     * Replace url parameters with the real value
     */
    const formattedUrl = formatObjectWithUrlKeys(userPermissionsHasAccess, params);

    const checkPagePermissions = (pathname: string) => {
        if (!(pathname in formattedUrl)) {
            return {
                pageHasPermissions: true
            };
        }

        return {
            pageHasPermissions: hasAcl(formattedUrl[pathname])
        };
    };

    return { checkPagePermissions };
};

export const useRequiresPermissions = () => {
    const pathname = usePathname();
    const { checkPagePermissions } = usePageHasPermissions();

    const { pageHasPermissions } = checkPagePermissions(pathname);

    return { hasAccess: pageHasPermissions, redirect_url: HOMEPAGE };
};
